import { SafeAny } from '@models/common';
import { extractError } from '@utils/error';
import axios from 'axios';
import { toast } from 'react-toastify';

const API = axios;

export const setBaseUrl = (url: string) => {
  axios.defaults.baseURL = url;
};

const handleApiError = (error: SafeAny) => {
  const errors = extractError(error.response.data);
  toast.error(errors.join(', '), {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
  });
};

export { API, handleApiError };
